export const INTL_TEL_INPUT_CONFIG = {
  separateDialCode: true,
  nationalMode: true,
  numberType: 'FIXED_LINE',
  preferredCountries: ['us', 'au', 'nz', 'gb'],
};
